<!-- Stamp alignment is hard coded for now and it can be deleted from CMS -->
<jb-promo-block-container class="db promo-block-spacing">
  <ng-container *ngFor="let block of blocks; let promoBlockIndex = index">
    <!-- TODO add [link] for routerLink if href begins with / once prod is all on SPA -->
    <jb-promo-block
      [id]="block.promoBlock.fsPromoID"
      *ngIf="block.promoBlock as promoBlock"
      [id]="promoBlock.fsPromoID || randomID"
      [href]="
        (block.afterLoadDynamicUrl$ | async) || block.fullPromoBlockLink
          | routerLinkFormatter: 'full'
      "
      [link]="
        (block.afterLoadDynamicUrl$ | async) || block.fullPromoBlockLink
          | routerLinkFormatter: 'url'
      "
      [linkParams]="
        (block.afterLoadDynamicUrl$ | async) || block.fullPromoBlockLink
          | routerLinkFormatter: 'params'
      "
      [theme]="promoBlock?.theme"
      [cardVAlignment]="promoBlock?.desktopVPosition"
      [cardHAlignment]="promoBlock?.desktopHPosition"
      [cardSize]="promoBlock?.size"
      [target]="
        promoBlock?.promoCard?.button[0]?.newWindow === newWindow._blank
          ? newWindow._blank
          : newWindow._self
      "
      [fullBleed]="block.fullBleed"
      [attr.data-order]="promoBlockIndex + 1"
    >
      <jb-promo-card
        class="charcoal"
        [opacity]="promoBlock.opacity"
        [bgColor]="promoBlock.color"
        [alignment]="promoBlock.contentAlignment"
        [class.three-up]="isThreeUp"
      >
        <jb-flag
          *ngIf="promoBlock.flag"
          [theme]="block.flagSettings.flagTheme"
          [title]="block.flagSettings.flagTitle"
          [roundedCorner]="block.flagSettings.flagAlignment"
        ></jb-flag>
        <div
          class="image-container"
          [style.--aspect-ratio]="
            (hasImageHeightWidthAttr &&
            promoBlock?.image &&
            promoBlock?.image.length > 0 &&
            +(promoBlock?.image)[0]?.height > 0 &&
            +(promoBlock?.image)[0]?.width > 0
              ? ((promoBlock?.image)[0]?.height /
                  (promoBlock?.image)[0]?.width) *
                100
              : 56.25) + '%'
          "
        >
          <jb-image
            *ngIf="promoBlock.image"
            [src]="promoBlock.image[0].src || ''"
            [alt]="promoBlock.image[0].alt"
            [isLazy]="enableLazyLoadImage"
            [height]="
              hasImageHeightWidthAttr && +(promoBlock?.image)[0]?.height > 0
                ? (promoBlock?.image)[0]?.height
                : null
            "
            [width]="
              hasImageHeightWidthAttr && +(promoBlock?.image)[0]?.width > 0
                ? (promoBlock?.image)[0]?.width
                : null
            "
          >
          </jb-image>
        </div>
        <ng-container JbTitle>
          <div
            [ngClass]="{
              white: promoBlock.theme === promoTheme.dark,
              'three-up-heading': isThreeUp
            }"
            [innerHTML]="block.dynamicTitle | async"
          ></div>
        </ng-container>
        <ng-container JbDescription>
          <div
            [ngClass]="{
              white: promoBlock.theme === promoTheme.dark,
              's-body': isThreeUp
            }"
            [innerHTML]="block.dynamicContent | async"
          ></div>
        </ng-container>
        <ng-container JbLegal *ngIf="promoBlock.legalCopy">
          <div
            class="legal-font"
            [ngClass]="{ white: promoBlock.theme === promoTheme.dark }"
            [innerHTML]="
              (block.dynamicLegalCopy$ | async) ||
              promoBlock?.legalCopy[0].content
            "
          ></div>
        </ng-container>
        <!-- Align items only works when there is an offer block element present (CL requirement) -->
        <jb-offer-block-container *ngIf="!block.offerBlocks" class="dn">
        </jb-offer-block-container>
        <jb-offer-block-container
          class="offer-block-container"
          *ngFor="let offerBlock of block.offerBlocks; let i = index"
        >
          <jb-offer-block
            [theme]="block.offerBlockTheme"
            [isClickable]="!!offerBlock.link?.href"
            [href]="
              (block.afterLoadDynamicUrl$ | async) || offerBlock.link?.href
            "
          >
            <jb-offer-block-text offerBlockHeader
              ><span
                [innerHtml]="
                  (block.afterLoadFlightDeal$ | async)?.header ||
                  offerBlock.header
                "
              ></span
            ></jb-offer-block-text>
            <!-- freeform is the ability to have open text inside an offer block -->
            <jb-offer-block-value
              [valueType]="
                offerBlock.valueType === 'freeform'
                  ? 'currency'
                  : (block.afterLoadFlightDeal$ | async)?.valueType ||
                    offerBlock.valueType
              "
              [currencySymbol]="
                offerBlock.valueType === 'freeform'
                  ? null
                  : (block.dynamicCurrencyCode$ | async) ||
                    (offerBlock.currencyCode | jbCurrencySymbol)
              "
              [discountSuffix]="offerBlock.discountSuffix"
              [pointsSuffix]="
                (block.afterLoadFlightDeal$ | async)?.pointsSuffix ||
                offerBlock.pointsSuffix
              "
            >
              <jb-inner-html
                *ngIf="offerBlock.valueType === 'freeform'"
                [innerHTML]="offerBlock.value"
              >
              </jb-inner-html>
              <ng-container *ngIf="offerBlock.valueType !== 'freeform'">
                {{
                  (block.afterLoadFlightDeal$ | async)?.price ||
                    offerBlock.value | number
                }}
              </ng-container>
            </jb-offer-block-value>
            <jb-offer-block-text offerBlockFooter>
              <ng-container
                *ngIf="
                  block.afterLoadFlightDeal$ | async as flightDeal;
                  else footerUsingOfferBlock
                "
              >
                <ng-container *ngIf="flightDeal.valueType === 'points'">
                  <span class="b">
                    {{
                      '+ ' +
                        (offerBlock.currencyCode | jbCurrencySymbol) +
                        (flightDeal.taxAmount | number: '1.2-2')
                    }}
                  </span>
                  {{ ' ' }}
                </ng-container>
                <span [innerHtml]="flightDeal.footer"></span>
              </ng-container>
              <ng-template #footerUsingOfferBlock>
                <ng-container *ngIf="offerBlock.valueType === 'points'">
                  <span class="b">
                    {{
                      '+ ' +
                        (offerBlock.currencyCode | jbCurrencySymbol) +
                        (offerBlock.taxes | number: '1.2-2')
                    }}
                  </span>
                  {{ ' ' }}
                </ng-container>
                <span [innerHtml]="offerBlock.footer"></span>
              </ng-template>
            </jb-offer-block-text>
          </jb-offer-block>
          <a
            *ngIf="
              !promoBlock?.promoCard?.externalButtons?.length &&
                promoBlock?.promoCard?.button[i] &&
                block.afterLoadDynamicUrl$ | async as dynamicLink
            "
            [attr.aria-label]="promoBlock.promoCard.button[i]?.title"
            jbButton
            size="small"
            [theme]="
              promoBlock.promoCard.button[i].style === buttonStyle.primary &&
              promoBlock.theme === promoTheme.light
                ? clButtonStyles.primary
                : promoBlock.promoCard.button[i]?.style ===
                    buttonStyle.primary && promoBlock.theme === promoTheme.dark
                ? clButtonStyles.secondary
                : clButtonStyles.standard
            "
            [jbSitemapLinker]="dynamicLink"
            [target]="
              promoBlock.promoCard.button[i]?.newWindow === newWindow._self
                ? newWindow._self
                : newWindow._blank
            "
            [dotLinkIcon]="
              promoBlock.promoCard.button[i]?.newWindow === newWindow._self
                ? null
                : newWindow._blank
            "
            >{{ promoBlock.promoCard.button[i]?.title }}</a
          >
          <a
            *ngIf="
              !(block.afterLoadDynamicUrl$ | async) &&
              !promoBlock.promoCard?.externalButtons?.length &&
              promoBlock.promoCard?.button[i]
            "
            [attr.aria-label]="promoBlock.promoCard.button[i]?.title"
            jbButton
            size="small"
            [theme]="
              promoBlock.promoCard.button[i].style === buttonStyle.primary &&
              promoBlock.theme === promoTheme.light
                ? clButtonStyles.primary
                : promoBlock.promoCard.button[i]?.style ===
                    buttonStyle.primary && promoBlock.theme === promoTheme.dark
                ? clButtonStyles.secondary
                : clButtonStyles.standard
            "
            [jbSitemapLinker]="promoBlock.promoCard.button[i]?.href"
            [target]="
              promoBlock.promoCard.button[i]?.newWindow === newWindow._self
                ? newWindow._self
                : newWindow._blank
            "
            [dotLinkIcon]="
              promoBlock.promoCard.button[i]?.newWindow === newWindow._self
                ? null
                : newWindow._blank
            "
            >{{ promoBlock.promoCard.button[i]?.title }}</a
          >
        </jb-offer-block-container>
        <a
          *ngFor="
            let outOfBlockButton of promoBlock.promoCard?.externalButtons;
            let first = first
          "
          [attr.aria-label]="outOfBlockButton?.title"
          jbButton
          [size]="
            promoBlock.promoCard.button.length > 1 || isThreeUp
              ? 'small'
              : 'large'
          "
          [class.mr7]="
            first && promoBlock?.promoCard?.externalButtons?.length === 2
          "
          [isFull]="isThreeUp ? true : false"
          [theme]="
            outOfBlockButton.style === buttonStyle.primary &&
            promoBlock.theme === promoTheme.light
              ? clButtonStyles.primary
              : outOfBlockButton?.style === buttonStyle.primary &&
                promoBlock.theme === promoTheme.dark
              ? clButtonStyles.secondary
              : clButtonStyles.standard
          "
          [jbSitemapLinker]="
            (block.afterLoadDynamicUrl$ | async) || outOfBlockButton?.href
          "
          [target]="
            outOfBlockButton?.newWindow === newWindow._self
              ? newWindow._self
              : newWindow._blank
          "
          [dotLinkIcon]="
            outOfBlockButton?.newWindow === newWindow._self
              ? null
              : newWindow._blank
          "
          (click)="$event.stopPropagation()"
          >{{ outOfBlockButton?.title }}</a
        >
        <!--          TODO add [attr.routerLink] for routerLink if href begins with / once-->
        <!--          prod is all on SPA-->
      </jb-promo-card>

      <!-- cant extract images to ng-templates or use ng-containers cause the children of jb-promo-block wont recognize and render them -->
      <!-- Images when only 1 block is available : Temporary fix-->
      <jb-overlay-image
        *ngIf="
          blocks.length === 1 &&
          (block.dynamicImage.url
            ? block.dynamicImage.isForeground
            : promoBlock.overlayImage)
        "
        [src]="
          block.dynamicImage?.url || promoBlock?.overlayImage[0]?.src
            | dynamicImageWidthPipe: 'overlay'
        "
        [imageSize]="promoBlock.overlayImage[0]?.imageSize"
        [cropped]="promoBlock.overlayImage[0]?.cropping !== 'fit'"
        [isLazy]="enableLazyLoadImage"
        [vPosition]="
          promoBlock.overlayImage[0]?.desktopVPosition
            ? promoBlock.overlayImage[0]?.desktopVPosition
            : alignment.top
        "
        [hPosition]="
          promoBlock.overlayImage[0]?.desktopHPosition
            ? promoBlock.overlayImage[0]?.desktopHPosition
            : alignment.top
        "
      >
      </jb-overlay-image>
      <jb-background
        *ngIf="
          blocks.length === 1 && (promoBlock.background || promoBlock.bgColor)
        "
        [repeat]="
          promoBlock.background &&
          promoBlock.background[0] &&
          promoBlock.background[0]?.repeat === 'true'
        "
        [src]="
          (block.dynamicImage?.isBackground &&
            (block.dynamicImage.url | dynamicImageWidthPipe: 'background')) ||
            (promoBlock.background && promoBlock?.background[0]?.src)
            | dynamicImageWidthPipe: 'background'
        "
        [color]="promoBlock.bgColor"
      >
      </jb-background>

      <!-- images for 2-3 blocks: Temporary Fix  -->
      <jb-promo-image
        *ngIf="
          blocks.length > 1 &&
          (promoBlock.background ||
            block.dynamicImage?.url ||
            promoBlock.overlayImage)
        "
        [isLazy]="enableLazyLoadImage"
        [src]="
          (block.dynamicImage?.url &&
            (block.dynamicImage.url | dynamicImageWidthPipe: 'background')) ||
            (promoBlock.overlayImage &&
              (promoBlock?.overlayImage[0]?.src
                | dynamicImageWidthPipe: 'background')) ||
            (promoBlock.background && promoBlock?.background[0]?.src)
            | dynamicImageWidthPipe: 'background'
        "
        class="aspect-ratio aspect-ratio--16x9"
      >
      </jb-promo-image>
      <jb-background
        *ngIf="blocks.length > 1 && promoBlock.bgColor"
        [color]="promoBlock.bgColor"
      >
      </jb-background>
      <!-- end of images -->
      <!-- end of pictures logic -->
    </jb-promo-block>
  </ng-container>
</jb-promo-block-container>
